import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import MarketingLayout from "@/components/MarketingLayout";

const PLANS = [
  {
    name: "Free",
    price: "$0",
    per: "forever",
    tag: "For discovering the craft.",
    features: ["1 project", "Basic screenplay editor", "50 AI credits / month", "PDF & Fountain export", "Community access"],
    cta: "Start free",
    testid: "plan-free",
  },
  {
    name: "Creator",
    price: "$18",
    per: "per month",
    tag: "For serious writers.",
    features: ["Unlimited projects", "AI Writer + Script Doctor", "1,000 AI credits / month", "Character Lab & Relationship graph", "Real-time collaboration", "Priority AI queue"],
    cta: "Choose Creator",
    highlight: true,
    testid: "plan-creator",
  },
  {
    name: "Studio",
    price: "$49",
    per: "per month",
    tag: "For directors and small studios.",
    features: ["Everything in Creator", "AI Director + Storyboard Studio", "5,000 AI credits / month", "Production dashboard, budget, schedule", "Advanced exports (FDX-compatible)", "Team seats (5)"],
    cta: "Choose Studio",
    testid: "plan-studio",
  },
  {
    name: "Enterprise",
    price: "Custom",
    per: "",
    tag: "For teams and studios at scale.",
    features: ["Everything in Studio", "SSO & role-based access", "Custom AI limits", "Dedicated support", "Custom integrations", "Volume discounts"],
    cta: "Talk to us",
    testid: "plan-enterprise",
  },
];

export default function Pricing() {
  const [annual, setAnnual] = React.useState(false);
  return (
    <MarketingLayout>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="uppercase text-xs tracking-[0.3em] text-[#D4AF37] mb-6">Pricing</div>
        <h1 className="font-editorial text-5xl sm:text-6xl leading-tight max-w-3xl">
          Pay for what you write.<br />
          <span className="italic text-[#A1A1AA]">Not what you might one day try.</span>
        </h1>
        <div className="mt-10 inline-flex border border-[#27272A]" role="tablist">
          <button onClick={() => setAnnual(false)}
            className={`px-6 py-2 text-sm ${!annual ? "bg-[#D4AF37] text-[#0A0A0A]" : "text-[#A1A1AA]"}`}
            data-testid="billing-monthly">Monthly</button>
          <button onClick={() => setAnnual(true)}
            className={`px-6 py-2 text-sm ${annual ? "bg-[#D4AF37] text-[#0A0A0A]" : "text-[#A1A1AA]"}`}
            data-testid="billing-annual">Annual · save 20%</button>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1E1E1E]">
        {PLANS.map((p) => (
          <div key={p.name}
            className={`p-8 flex flex-col ${p.highlight ? "bg-[#141414] border-t-2 border-[#D4AF37]" : "bg-[#0A0A0A]"}`}
            data-testid={p.testid}>
            <div className="uppercase text-[11px] tracking-widest text-[#71717A]">{p.name}</div>
            <div className="mt-6 flex items-baseline gap-2">
              <div className="font-editorial text-5xl">
                {annual && p.price.startsWith("$") && p.price !== "$0"
                  ? `$${Math.round(parseInt(p.price.slice(1)) * 0.8)}`
                  : p.price}
              </div>
              {p.per && <div className="text-xs text-[#71717A]">/ {p.per}</div>}
            </div>
            <div className="mt-3 text-sm text-[#A1A1AA] italic">{p.tag}</div>
            <ul className="mt-8 space-y-3 text-sm flex-1">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-[#E4E4E7]">
                  <Check size={14} className="text-[#D4AF37] mt-0.5 shrink-0" strokeWidth={2} /> {f}
                </li>
              ))}
            </ul>
            <Link to="/signup"
              className={`mt-8 py-3 text-center text-sm font-medium ${p.highlight ? "bg-[#D4AF37] text-[#0A0A0A] hover:bg-[#F59E0B]" : "border border-[#27272A] hover:border-[#A1A1AA] text-[#FFFFF0]"} transition-colors`}
              data-testid={`${p.testid}-cta`}>
              {p.cta}
            </Link>
          </div>
        ))}
      </section>
    </MarketingLayout>
  );
}
